/*
 * Normcore navigation for A1 — UX batida D-1 and D-3 (Javi, 2026-10-23). No dependencies.
 * The nc-* screens announce navigation as events (nc-*:open, :action, :navigate, :upload) because real routing is Phase B.
 * Nothing listened to them, so cards, "Ver todos", "Subir look" and friends did nothing. This file is that listener:
 *   - it opens the screens whose route is approved or already exists: look detail (R-8, /pages/look?id=), product detail
 *     (?product=, PROPOSED until /products/:handle in Phase B), Subir look, login;
 *   - every other Phase B intent gets one short notice ("Esta función estará disponible pronto.") instead of silence;
 *   - an <a href="#"> that nobody handled no longer jumps to the top of the page, and a "⋮" trigger with no menu behind it
 *     no longer does nothing: both get the same notice.
 * Routes come from the JSON printed by snippets/nc-route-map.liquid, so they resolve exactly like nc-route in Liquid
 * (preview fallback /pages/profile?view=<template> while the pages do not exist).
 *   NcNav.url(to, params)  -> URL string of a route with params appended, or '' when the route is unknown
 *                             ('brand_corner' takes params.slug, the brand collection's handle)
 *   NcNav.go(to, params)   -> navigates; false when the route is unknown
 *   NcNav.notice()         -> shows the "coming soon" notice (one at a time)
 *   Products (F-3, Javi 2026-10-23): a store product ('store-<shopify id>' with a handle in the gateway mock's STORE_PRODUCTS)
 *   opens the theme's real product page /products/<handle>; any other product keeps the nc product detail (?product=).
 *   NcNav.productPath(id, products) is the pure lookup; NcNav.url('product', {product: id}) applies it.
 *   NcNav.resolve(name, detail) -> pure: { go: [to, params] } | { notice: true } | null (exported for tests)
 */
(function (root) {
  if (root.NcNav) return; // several nc sections on one page (the home) each load this file: listeners are bound once
  var GO = function (to, params) { return { go: [to, params || null] }; };
  var NOTICE = { notice: true };

  // event name -> detail -> outcome. null = the screen already gives its own feedback or navigates through a real href.
  var RULES = {
    'nc-profile:action': function (d) {
      if (d.action === 'open-look') return GO('look', { id: d.id });
      if (d.action === 'open-garment') return GO('product', { product: d.id });
      if (d.action === 'edit-profile' || d.action === 'view-garments') return null;
      return NOTICE;
    },
    'nc-community:action': function (d) {
      if (d.action === 'open' || d.action === 'comment') return GO('look', { id: d.id });
      if (d.action === 'sign-in') return GO('login');
      if (d.action === 'try') return null;
      if (d.action === 'back') return { back: true };
      return NOTICE;
    },
    'nc-community:upload': function () { return GO('upload'); },
    'nc-inspire:upload': function () { return GO('upload'); },
    'nc-favorites:open': function (d) { return byKind(d); },
    'nc-inspire:open': function (d) { return byKind(d); },
    'nc-upload-community:open': function (d) { return byKind(d); },
    'nc-inspire:browse': function () { return NOTICE; },
    'nc-inspire:styles': function () { return NOTICE; },
    'nc-history:action': function (d) {
      if (d.action === 'detail') return d.entityId ? GO('look', { id: d.entityId }) : NOTICE;
      if (d.action === 'open-garment') return d.entityId ? GO('product', { product: d.entityId }) : NOTICE;
      if (d.action === 'try' || d.action === 'unfav') return null;
      return NOTICE;
    },
    'nc-generate-looks:open': function (d) { return d.kind === 'catalog' ? null : byKind(d); },
    'nc-search:open-product': function (d) { return GO('product', { product: d.id }); },
    'nc-search:action': function () { return NOTICE; },
    'nc-product:open': function (d) { return d.kind === 'post' ? GO('look', { id: d.id }) : byKind(d); },
    'nc-product:store': function () { return NOTICE; },
    'nc-product:size-guide': function () { return NOTICE; },
    'nc-product:view-full': function () { return NOTICE; },
    // a garment with a real href (the card's anchor) navigates by itself; without one the event still routes it
    'nc-look-detail:action': function (d) { return d.action === 'open-garment' && !d.href ? GO('product', { product: d.productId }) : null; },
    'nc-brand-hub:open': function (d) { return byKind(d); },
    'nc-brand-corner:open': function (d) { return d.source === 'featured' ? null : byKind(d); },
    'nc-fitting:open': function (d) { return d.kind === 'product' ? GO('product', { product: d.id }) : null; }
  };

  function byKind(d) {
    if (d.kind === 'look') return GO('look', { id: d.id });
    if (d.kind === 'product') return GO('product', { product: d.id });
    return NOTICE;
  }

  function resolve(name, detail) {
    var rule = RULES[name];
    return rule ? rule(detail || {}) : null;
  }

  function withQuery(url, params) {
    if (!url || !params) return url || '';
    var parts = [];
    for (var k in params) if (params[k] !== undefined && params[k] !== null && params[k] !== '') parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k]));
    if (!parts.length) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + parts.join('&');
  }

  // '/products/<handle>' for a store product, '' for anything else (then the nc product detail is used). products = [{id, handle}]
  function productPath(id, products) {
    if (typeof id !== 'string' || id.indexOf('store-') !== 0) return '';
    var list = products || [];
    for (var i = 0; i < list.length; i++) if (list[i] && list[i].id === id && list[i].handle) return '/products/' + encodeURIComponent(list[i].handle);
    return '';
  }

  var api = { resolve: resolve, withQuery: withQuery, productPath: productPath, RULES: Object.keys(RULES) };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  if (typeof document === 'undefined' || root.NcNav) return;

  var routes = null;
  var comingSoon = 'Esta función estará disponible pronto.';
  var shown = null;
  function load() {
    if (routes) return routes;
    var el = document.querySelector('script[data-nc-routes]');
    routes = {};
    if (el) {
      try { routes = JSON.parse(el.textContent); } catch (e) { routes = {}; }
      comingSoon = el.getAttribute('data-coming-soon') || comingSoon;
    }
    routes.login = routes.login || '/account/login';
    return routes;
  }
  api.url = function (to, params) {
    if (to === 'product' && params && params.product) {
      var store = productPath(params.product, root.NcGatewayMock && root.NcGatewayMock.STORE_PRODUCTS);
      if (store) return store;
    }
    var u = load()[to];
    if (!u || u === '#') return '';
    // brand_corner (R-2): the brand collection's handle is part of the path, /collections/{slug}?view=marca; other params are a query
    if (u.indexOf('{slug}') >= 0) {
      if (!params || !params.slug) return '';
      var rest = {};
      for (var k in params) if (k !== 'slug') rest[k] = params[k];
      return withQuery(u.replace('{slug}', encodeURIComponent(params.slug)), rest);
    }
    return withQuery(u, params);
  };
  api.go = function (to, params) { var u = api.url(to, params); if (!u) return false; window.location.assign(u); return true; };
  api.notice = function () {
    load();
    if (shown && shown.isConnected) return; // one notice at a time, repeated clicks do not stack toasts
    if (window.NcToast) shown = window.NcToast.show({ tone: 'success', message: comingSoon, duration: 3000 });
  };
  root.NcNav = api;

  Object.keys(RULES).forEach(function (name) {
    document.addEventListener(name, function (event) {
      var out = resolve(name, event.detail);
      if (!out) return;
      if (out.back) { window.history.back(); return; }
      if (out.go && api.go(out.go[0], out.go[1])) return;
      api.notice();
    });
  });

  // Look -> garment (UX look/ficha, 1-11): the product page offers "Volver al look" with what is stored here (sessionStorage, 30 min, never blocks);
  // a click on a card's photo has no anchor, so it navigates here too. The title and strip anchors navigate by themselves.
  document.addEventListener('nc-look-detail:action', function (event) {
    var d = event.detail || {};
    if (d.action !== 'open-garment') return;
    try { if (d.lookId) window.sessionStorage.setItem('nc-from-look', JSON.stringify({ id: d.lookId, title: d.lookTitle || '', url: window.location.pathname + window.location.search, at: Date.now() })); } catch (e) { /* storage off: no back link */ }
    if (d.viaMedia && d.href) window.location.assign(d.href);
  });

  // a "⋮" menu trigger that no screen wired (community cards inside Perfil, Generar looks, Hub): if no menu or sheet opened
  // for it by the end of the click, say so instead of doing nothing
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('button[aria-haspopup="menu"]');
    if (!trigger || !trigger.closest('[data-nc-main]') || trigger.hasAttribute('aria-controls')) return;
    setTimeout(function () {
      if (trigger.getAttribute('aria-expanded') === 'true') return;
      if (document.querySelector('.nc-sheet:not([hidden]), .nc-menu__surface:not([hidden])')) return;
      api.notice();
    }, 0);
  });

  // The cards the controllers clone from their <template>s start with href="#". Once the route map is here, every such link inside an nc screen
  // gets the page of its entity (a look, a garment, a history row's entity) or loses the href: a card without destination is not a link, never "#".
  // Collections have no page, so their cards lose the link. Controllers keep their own behaviour; this only fixes the href.
  function linkCards() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nc-main] a[href="#"]'), function (a) {
      var card = a.closest('.nc-look-card, .nc-product-card, .nc-collection-card, .nc-activity-row');
      if (!card) return;
      var id = card.getAttribute('data-entity-id') || card.getAttribute('data-id') || '', to = '';
      if (card.classList.contains('nc-look-card')) to = 'look';
      else if (card.classList.contains('nc-product-card')) to = 'product';
      else if (card.classList.contains('nc-activity-row')) to = card.getAttribute('data-kind') === 'garment' ? 'product' : 'look';
      // a look generated by the try-on (render id) has no page of its own yet: its row keeps the buttons, the title is not a link
      var href = id && to && !(to === 'look' && /^(rnd_|gl-r-)/.test(id)) ? api.url(to, to === 'look' ? { id: id } : { product: id }) : '';
      if (href) a.setAttribute('href', href); else a.removeAttribute('href');
    });
  }
  api.linkCards = linkCards;
  var linkTimer = 0;
  function scheduleLinkCards() { if (linkTimer) return; linkTimer = setTimeout(function () { linkTimer = 0; linkCards(); }, 30); }
  document.addEventListener('DOMContentLoaded', scheduleLinkCards);
  window.addEventListener('load', scheduleLinkCards);
  if (typeof MutationObserver === 'function') new MutationObserver(scheduleLinkCards).observe(document.documentElement, { childList: true, subtree: true });

  // a "#" link inside an nc screen that no component handled (it would jump to the top): stop the jump, say why
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    var a = event.target.closest && event.target.closest('a[href="#"]');
    if (!a || !a.closest('[data-nc-main]')) return;
    event.preventDefault();
    api.notice();
  });
})(typeof window !== 'undefined' ? window : this);
